import { render, staticRenderFns } from "./CalendarioVenda.vue?vue&type=template&id=365815af"
import script from "./CalendarioVenda.vue?vue&type=script&lang=js"
export * from "./CalendarioVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365815af')) {
      api.createRecord('365815af', component.options)
    } else {
      api.reload('365815af', component.options)
    }
    module.hot.accept("./CalendarioVenda.vue?vue&type=template&id=365815af", function () {
      api.rerender('365815af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/CalendarioVenda.vue"
export default component.exports